import { Component, OnInit } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { adminUser } from '../models/adminUser';
import { ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrManager } from 'ng6-toastr-notifications';
import { TableUtil } from '../tableUtil';
import { Router } from '@angular/router';
import { adminUserFilter } from '../filterModels/adminUser';
import { ImageCompressService } from 'ng2-image-compress';
import { ExcelService } from '../service/tableUtility.service';



@Component({
  selector: 'app-adminusermanagement',
  templateUrl: './adminusermanagement.component.html',
  styleUrls: ['./adminusermanagement.component.css']
})

export class AdminusermanagementComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("adminUser") form: any;
  @ViewChild("adminUserUpdate", { static: true }) formUpdate: any;
  adminFilterObj:adminUserFilter
  myurl: string;
filterValueSelected:any
searchValue:any
  show: boolean = false
  showFilter: boolean = false
  mobilevalidation: any
  showCustomisedSearch: boolean = false
  adminUserAddObj: adminUser
  dataSource: any;
  userSession: any;
  userDetails: any;
  userSessionData: any;
  image = { 'URL': '', 'valid': false };
  data: any;
  read: any;
  write: any;
  delete: any;
  export:any;
  displayedColumns = ['firstName', 'lastName', 'mobileNumber','mobileNumberStatus', 'emailId', 'emailIdStatus','roleId','RoleName', 'profilePhoto','status','dateOfCreation','dateOfModification', 'Action']
  users: [] = [];
  rolesList: [] = [];
  pic: any;
  adminUsersList: any

  constructor(private router: Router, private cs: CucurachaAdminService, private toastr: ToastrManager, private excelService: ExcelService) {
    this.adminUserAddObj = new adminUser();
    this.myurl = this.cs.endpoint;
    this.adminFilterObj=new adminUserFilter()

  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAdminUsers();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForAdminUsers(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAdminUsers()
    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  saveAdminUser() {
    this.cs.saveAdminUser(this.adminUserAddObj).subscribe((data) => {
      if (data.result) {
        this.getAdminUsers();
        this.toastr.successToastr(data.message);
        this.form.reset();
        this.pic = ""


      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }
    });
  }
  addAdmin() {
    this.pic = ""

    if (this.show == false) {
      this.show = true
      this.formUpdate.reset()
      this.form.reset()

    }
    else {
      this.pic = ""

      this.show = false
      this.form.reset();
      this.formUpdate.reset()



    }
  }
  filter() {
    this.getAdminUsers()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""


      this.form.reset();

    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""

      this.form.reset();



    }
  }


  getAdminUsers() {
    this.cs.getallAdminUsers().subscribe((data) => {
      console.log(data)
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator

    });
  }
  deleteAdminUser(id: any) {
    this.cs.delteAdminUsers(id).subscribe((data) => {
      this.getAdminUsers()
      this.toastr.warningToastr("Data  Deleted");


    })

  }
  getByAdminId(id: any) {
    this.cs.getByAdminId(id).subscribe((data) => {
      this.adminUserAddObj._id = data[0]._id;
      this.adminUserAddObj.roleId = data[0].roleId;

      this.adminUserAddObj.id = data[0].id;
      this.adminUserAddObj.firstName = data[0].firstName
      this.adminUserAddObj.lastName = data[0].lastName
      this.adminUserAddObj.emailId = data[0].emailId
      this.adminUserAddObj.mobileNumber = data[0].mobileNumber
      this.adminUserAddObj.passWord = data[0].passWord
      this.adminUserAddObj.roleId = data[0].roleId
      this.pic = this.myurl + 'Misc/Images/profilePhotos/' + data[0]._id
    })

  }

  updateAdminUser() {
    this.cs.updateAdminUser(this.adminUserAddObj).subscribe((data) => {
      if (data.result) {
        this.getAdminUsers();
        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();

      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }
    });

  }
  exportTable() {
    this.users = (this.dataSource.filteredData)
    this.excelService.exportAsExcelFile(this.users, 'Adminuser');
    this.cs.exportLogAdd(this.userDetails.emailId,'AdminuserManagement').subscribe((data) => {
    })
  }
  onChange(status, id) {
    console.log(status.checked)
    this.cs.getByAdminId(id).subscribe((data) => {
      this.adminUserAddObj._id = data[0]._id;
      this.adminUserAddObj.roleId = data[0].roleId;

      this.adminUserAddObj.id = data[0].id;
      this.adminUserAddObj.firstName = data[0].firstName
      this.adminUserAddObj.lastName = data[0].lastName
      this.adminUserAddObj.emailId = data[0].emailId
      this.adminUserAddObj.mobileNumber = data[0].mobileNumber
      this.adminUserAddObj.passWord = data[0].passWord
      this.adminUserAddObj.roleId = data[0].roleId
      this.adminUserAddObj.status = status.checked;

      this.cs.updateAdminUserstatus(this.adminUserAddObj).subscribe((data) => {
        if(data.result ){
          this.ngOnInit();
          this.toastr.successToastr(data.message);
          this.form.reset();
          
          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
    
         }
          else{
            this.toastr.errorToastr(data.message);
    
          }
      })
    })
  }
  fileChangeEvent(fileInput: any) {
    ImageCompressService.filesToCompressedImageSource(fileInput.target.files).then(observableImages => {
      observableImages.subscribe((image) => {
        this.image.URL = image.compressedImage.imageDataUrl;
        this.adminUserAddObj.profilePhoto = image.compressedImage.imageDataUrl;
        this.adminUserAddObj.profilePhoto = this.adminUserAddObj.profilePhoto.replace("data:image/gif;base64,", "");
        this.adminUserAddObj.profilePhoto = this.adminUserAddObj.profilePhoto.replace("data:image/jpeg;base64,", "");
        this.adminUserAddObj.profilePhoto = this.adminUserAddObj.profilePhoto.replace("data:image/jpg;base64,", "");
        this.adminUserAddObj.profilePhoto = this.adminUserAddObj.profilePhoto.replace("data:image/png;base64,", "");
        this.pic = image.compressedImage.imageDataUrl
      }, (error) => {
        this.toastr.errorToastr("Error while converting");
      });
    });
  }
  getAllRoles() {
    this.cs.getAllRolesforAdminUser().subscribe((data) => {
      this.rolesList = data
    })
  }


  ngOnInit(): void {
    this.getAdminUsers()
    this.getAllRoles()
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
      this.read = (this.userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].read);
      this.write = (this.userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].write)
      this.delete = (this.userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].delete)
      this.export = (this.userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].export)

    })
  }

}
